import { Button, ButtonProps, Modal, IconButton } from "@mui/material";
import { FunctionComponent, ReactElement, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import ContainerModal from "./containerModal";

interface ModalOpenProps {
  children: ReactElement | ReactElement[]
  title?: string
  buttonStyle?: ButtonProps
}

const ModalOpen: FunctionComponent<ModalOpenProps> = ({ children, title, buttonStyle }) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const handleOpen = () => setIsOpen(true);
  const handleClose = () => setIsOpen(false);

  return (
    <>
      <Modal open={isOpen} onClose={handleClose}>
        <ContainerModal>
          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            <IconButton onClick={handleClose} aria-label="Fechar">
              <CloseIcon />
            </IconButton>
          </div>
          {children}
        </ContainerModal>
      </Modal>
      <Button onClick={handleOpen} {...buttonStyle}>
        <p>{title}</p>
      </Button>
    </>
  );
};

export default ModalOpen;
